/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Owners
 */
export interface Owners {
    /**
     * 
     * @type {string}
     * @memberof Owners
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Owners
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Owners
     */
    patronymicName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Owners
     */
    type: OwnersTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof Owners
     */
    birthday?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof Owners
     */
    percent?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Owners
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof Owners
     */
    readonly deal?: number;
    /**
     * 
     * @type {number}
     * @memberof Owners
     */
    readonly user?: number;
    /**
     * 
     * @type {number}
     * @memberof Owners
     */
    readonly contact?: number;
    /**
     * 
     * @type {Date}
     * @memberof Owners
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Owners
     */
    readonly updatedAt?: Date;
}

export function OwnersFromJSON(json: any): Owners {
    return OwnersFromJSONTyped(json, false);
}

export function OwnersFromJSONTyped(json: any, ignoreDiscriminator: boolean): Owners {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'patronymicName': !exists(json, 'patronymicName') ? undefined : json['patronymicName'],
        'type': json['type'],
        'birthday': !exists(json, 'birthday') ? undefined : (json['birthday'] === null ? null : new Date(json['birthday'])),
        'percent': !exists(json, 'percent') ? undefined : json['percent'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deal': !exists(json, 'deal') ? undefined : json['deal'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

export function OwnersToJSON(value?: Owners | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lastName': value.lastName,
        'firstName': value.firstName,
        'patronymicName': value.patronymicName,
        'type': value.type,
        'birthday': value.birthday === undefined ? undefined : (value.birthday === null ? null : value.birthday.toISOString().substr(0,10)),
        'percent': value.percent,
    };
}

/**
* @export
* @enum {string}
*/
export enum OwnersTypeEnum {
    Unmarried = 'unmarried',
    Spouse = 'spouse',
    Child = 'child',
    Teenager = 'teenager',
    Foreigner = 'foreigner'
}


